import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	x: 0,
	y: 0,
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(.337 .337)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 8.7,
				cy: 8.7,
				r: 8,
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.7 4.8v7.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.5 8.7H4.8",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round"
			})
		]
	})
});
export { SvgWon as ReactComponent };
